import { useQuery } from "react-query";
import { fetchTranslationExports } from "../../api/translationExports";
import ExportTranslationCacheName from "../../utils/ExportTranslationCacheName";

// hook to fetch (GET) translation exports from DB
export const useFetchTranslation = () => {
  return useQuery({
    queryKey: [ExportTranslationCacheName.getExportTranslation()],
    queryFn: fetchTranslationExports,
    refetchOnMount: true,
  });
};
